import React from 'react';
import { INTERCOM_APP_ID } from 'constants/application_constants';

const Intercom = ({ user, children }) => {
  React.useEffect(() => {
    // Set up Intercom settings
    window.intercomSettings = {
      api_base: "https://api-iam.intercom.io",
      app_id: INTERCOM_APP_ID,
      user_id: user?.id,
      name: user?.name,
      email: user?.email,
      created_at: user?.createdAt,
    };

    // Load Intercom widget
    (function(){
      var w = window;
      var ic = w.Intercom;
      if (typeof ic === "function") {
        ic('update', w.intercomSettings);
      } else {
        var d = document;
        var i = function(){
          i.c(arguments);
        };
        i.q = [];
        i.c = function(args){
          i.q.push(args);
        };
        w.Intercom = i;
        var l = function(){
          var s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://widget.intercom.io/widget/' + INTERCOM_APP_ID;
          var x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        };
        if (document.readyState === 'complete') {
          l();
        } else if (w.attachEvent) {
          w.attachEvent('onload', l);
        } else {
          w.addEventListener('load', l, false);
        }
      }
    })();
  }, []);

  return children;
};

export default Intercom;